<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline label-suffix=":" label-width="90px">
        <el-form-item label="城市">
          <el-select v-model="formData.cityId" clearable>
            <el-option
              v-for="it in cityList"
              :key="it.value"
              :label="it.name"
              :value="it.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-select v-model="formData.companyId" clearable>
            <el-option
              v-for="it in stores"
              :key="it.storeId"
              :label="it.storeName"
              :value="it.storeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品编码">
          <el-input
            v-model="skuIdStr"
            style="width: 220px"
            clearable
            placeholder="请输入商品编码,多个用','分隔"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-form inline label-suffix=":" label-width="90px">
        <el-form-item label="查询日期">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-left: 10px; width: 500px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onSearch({ page: 1 })"
            >查询</el-button
          >
          <el-button type="primary" @click="onExportTask({ page: 1 })"
            >导出</el-button
          >
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="tableData" border stripe>
        <el-table-column label="商品编码" prop="goodsId" />
        <el-table-column label="商品名称" prop="goodsName" />
        <el-table-column label="商品类型"  >
          <template slot-scope="scope">
            {{ goodsTypeMap[scope.row.goodsType]||'-'  }}
          </template>
        </el-table-column>
        <el-table-column label="规格" prop="specifications" >
          <template slot-scope="scope">
            {{ scope.row.specifications||'-'  }}
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="unit" >
          <template slot-scope="scope">
            {{ scope.row.unit||'-'  }}
          </template>
        </el-table-column>
        <el-table-column label="下单量" prop="amount" >
          <template slot-scope="scope">
            {{ scope.row.amount.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="实收量" prop="receiveBackAmount" >
          <template slot-scope="scope">
            {{ scope.row.receiveBackAmount.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="无税金额(元)" prop="nonTaxMoney" >
          <template slot-scope="scope">
            {{ scope.row.nonTaxMoney.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="含税金额(元)" prop="taxMoney" >
          <template slot-scope="scope">
            {{ scope.row.taxMoney.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="下单门店汇总" prop="companyNameStr" />
        <el-table-column label="下单门店id汇总" prop="companyIdStr" />
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="onSearch({})"
          @current-change="onSearch({})"
          :current-page.sync="formData.page"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { dateTimeFormatter } from "@/utils/utils.js";
import { getBaseUrl, exportFile } from "@/framework/utils/tools";

export default {
  data() {
    const end = new Date();
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 0);
    return {
      goodsTypeMap:{1:'商品',2:'包装物'},
      cityList: [],
      daterange: [start.getTime(), end.getTime()],
      skuIdStr: "",
      createTime: [],
      stores: [],
      formData: {
        pageSize: 10,
        page: 1,
        startTime: "",
        endTime: "",
        fieldOrder: "asc",
        fieldSort: "id",
        cityId: "",
        customerId: "",
        companyId: "",
        goodsIds: [],
      },
      total: 0,
      loading: false,
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 0);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 0);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate(time) {
          let cur_time = new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() > cur_time + 86400000 - 1000;
        },
      },
    };
  },
  created() {
    // this.getCitys();
  },
  mounted() {
    this.initStore();
    this.initCity();
  },
  // beforeRouteEnter(to, from, next) {
  // next(async (vm) => {
  //   const { ret, data } = await _api.bill.getStore();
  //   if (ret && data && data.length) {
  //     vm.stores = data;
  //   } else {
  //     vm.stores = [];
  //   }
  // });
  // },
  methods: {
    initCity(){
      _api
        .post("/group/group-biz-city", {})
        .then(({data}) => {
          if(data){
            this.cityList=data;
          }
        })
        .catch((e) => {
          this.$message.error("查询商品列表失败:" + e);
        });
    },
    initStore() {
      _api.bill
        .getStore()
        .then(({ ret, data }) => {
          if (ret && data && data.length) {
            this.stores = data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    buildParam(){
      const [startTime, endTime] = this.daterange;
      if (!startTime || !endTime) {
        this.$message.error("请选择正确的时间范围");
        return null;
      }
      this.formData.startTime = startTime / 1000;
      this.formData.endTime = endTime / 1000;
      const skuIds = this.skuIdStr
        .replaceAll(/,， /g, ",")
        .split(",")
        .filter((v) => !isNaN(v)&&v);
      let param = {
        pageSize: this.formData.pageSize,
        page: this.formData.page,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        fieldOrder: "asc",
        fieldSort: "id",
        cityId: this.formData.cityId || null,
        customerId: null,
        companyId: this.formData.companyId || null,
        goodsIds: [],
      };
      if (skuIds && skuIds.length > 0) {
        param.goodsIds = skuIds;
      }
      return param;
    },
    onSearch({ page }) {
      if (page) {
        this.formData.page = page;
      }
      const param = this.buildParam();
      if(!param){
        return;
      }
      this.loading = true;
      _api
        .post("/group/bill-query-goods-for-page", param)
        .then((res) => {
          if (!res.ret) {
            this.$message.error("查询商品列表失败:" + res.message);
          } else {
            this.total = res.data.totalCount;
            this.tableData = [];
            if (res.data.items) {
              this.tableData = res.data.items;
            }else{
              this.tableData = []
            }
          }
        })
        .catch((e) => {
          this.$message.error("查询商品列表失败:" + e);
        }).finally(()=>{
          this.loading = false;
        });
    },
    onExportTask({ page }) {
      if (page) {
        this.formData.page = page;
      }
      const param = this.buildParam();
      if(!param){
        return;
      }
      this.loading = true;
      _api
        .post("/group/bill-create-export-task", param)
        .then(({ret,data,error}) => {
          if (!ret) {
            this.$message.error("创建导出任务失败:" + error?error.msg:'');
          } else {
            this.$message.success("创建成功:" + data);
          }
        })
        .catch((e) => {
          this.$message.error("创建导出任务失败:" + e);
        }).finally(()=>{
          this.loading = false;
        });
    },
    // toDetail(row){
    //   if(row){
    //     this.$router.push({
    //       path: "/orderManagement/detail",
    //       query: {
    //         storeId:row.storeId,
    //         orderId:row.orderId
    //       }
    //     });
    //   }
    // },
    _formatDate(ct) {
      return ct ? dateTimeFormatter(ct * 1000, "YYYY-MM-DD HH:mm:ss") : "--";
    },
    async getCitys() {
      const res = await _api.bill.getBizCitys({
        type: 1, // 1 则是美菜城市
        // status: 1 // 1开通 不传或者null 取所有
      });
      if (!res || !res.ret || !res.data) {
        this.cityList = [];
        return;
      }
      this.cityList = res.data || [];
    },
    //导出
    async exportFile() {
      // if (this.total > 5000) {
      //   this.$message({
      //     type: "warning",
      //     message: "导出数据需≤5000条，请减少导出量"
      //   });
      //   return;
      // }
      // this.$message({
      //   type: "warning",
      //   message: "正在导出，请稍后"
      // });
      this.loading = true;
      const { ret, data } = await _api.bill.export(this.formData);

      this.loading = false;

      if (ret) {
        this.$message({
          type: "warning",
          message: data,
        });
      }

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
  },
};
</script>
<style>
.img li {
  float: left;
  margin-left: 5px;
  list-style-type: none;
}
</style>
